import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function getAssignedStudents(coursedata) {
  try {
    const response = await axiosInstance.post('course/getAssignedStudents', coursedata);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
